import { call } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { STRETCH_POST_EVENT_CONSUME } from "../../state/user/constants";

function* postConsumeEvent({ payload }) {
  try {
    yield call(Axios.core.post, STRETCH_POST_EVENT_CONSUME, {
      ...payload
    });
  } catch (e) {
    // TODO Use a logger
  }
}

export default postConsumeEvent;
